//@flow

import styled from 'styled-components'
import _ from 'lodash'
import React, { useRef, useState } from 'react'
import { useSelector } from 'react-redux'
import { getCurrentApp } from 'e-submission/apps/selectors'
import { getLuckyNumberStatus } from 'e-submission/domain/data-model/form/selectors'
import Icon from 'e-submission/components/Icon'
import { ModalBody, ModalHeader, ModalFooter, Button } from 'reactstrap'
import { Modal } from 'common-components/index'
import { Link } from 'react-router-dom'

const ModalTitleSection = styled(ModalHeader)`
  .close {
    margin-top: -8px;
  }
  .modal-title {
    width: 100%;
  }
  .modal-header-sub-title {
    text-align: center;
    font-weight: bold;
    display: block;
    color: ${({ theme }) => theme.variables['$brand-primary']};
    margin-left: 16.5px;
  }
`

const SearchNumbersTitle = styled.div`
  margin-bottom: 24px;

  .title-text {
    font-size: 1.325rem;
    color: #2425aa;
    font-weight: bold;
  }

  .text {
    margin: 0;
  }

  .subtitle {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .text {
      flex: 1 1 50%;
    }
  }

  .clear-button {
    font-size: 1rem;
    color: #2425aa;
    font-weight: bold;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    margin-right: -8px;

    span {
      align-items: center;
      display: flex;
    }
  }

  .auto-assign-button {
    font-size: 1rem;
    color: #2425aa;
    cursor: pointer;
    background: none;
    border: none;
    outline: none;
    margin-right: -8px;
    text-decoration: underline;

    span {
      align-items: center;
      display: flex;
    }
  }

  .search-button {
    color: #2425aa;
    background: white;
    border-radius: 8px;
    align-content: center;
    height: 44px;
    text-align: center;
    width: 150px;
    border: 1px solid;
    cursor: pointer;

    span {
      padding-right: 10px;
      justify-content: center;
      align-items: center;
      display: flex;
    }
  }

  .digits {
    display: flex;
    justify-content: space-between;
    font-weight: 300;
    margin: 20px -4px 30px;
  }

  .digit-blue {
    align-content: center;
    width: 70px;
    height: 48px;
    font-size: 24px;
    text-align: center;
    margin: 0 4px;
    color: white;
    border-radius: 8px;
    background: #2425aa;
    border: none;
  }

  .dash {
    font-size: 32px;
    align-content: center;
    margin: 0 4px;
  }

  .digit,
  .digit-add-margin {
    width: 48px;
    height: 48px;
    font-size: 24px;
    text-align: center;
    margin: 0 4px;
    color: #2425aa;
    border-radius: 8px;
    border-color: azure;
    border: 1px solid #ccc;
  }

  .digit-add-margin {
    margin-right: 24px;
  }

  @media screen and (max-width: 650px) {
    .digit,
    .digit-add-margin {
      margin: 0 2px;
    }
  }

  @media screen and (max-width: 600px) {
    .digit-blue {
      width: 44px;
      height: 40px;
      font-size: 20px;
    }

    .digit,
    .digit-add-margin {
      width: 40px;
      height: 40px;
      margin: 0 2px;
      font-size: 20px;
    }
  }

  @media screen and (max-width: 450px) {
    .digit-blue {
      width: 34px;
      height: 33px;
      font-size: 18px;
    }

    .digit,
    .digit-add-margin {
      width: 33px;
      height: 33px;
      margin: 0 2px;
      font-size: 18px;
    }
  }
`

const LuckyNumberInput = ({
  value = Array(7).fill(''),
  onChange,
  searchLuckyNumberOptions,
  setAutoAssignLuckyNumber,
  setConfirmLuckyNumberModal,
  setAutoAssignFailedModal,
  submitSelectedLuckyNumber,
}) => {
  const state = useSelector((state) => state)
  const app = getCurrentApp(state)
  const luckyNumberStatus = getLuckyNumberStatus(app)

  const isConfirmLuckyNumberModal = _.get(state, `ui.isConfirmLuckyNumberModal`)
  const isAutoAssignFailedModal = _.get(state, `ui.isAutoAssignFailedModal`)

  const inputsRef = useRef([])
  const handleKeyDown = (e, index) => {
    const newValues = [...value]
    const keyDown = e.key
    if (/^\d$/.test(keyDown)) {
      newValues[index] = keyDown
      onChange(newValues)
      if (index < 6) {
        inputsRef.current[index + 1].focus()
      }
    } else if (keyDown === 'Backspace') {
      const newValues = [...value]
      if (newValues[index] !== '') {
        newValues[index] = ''
        onChange(newValues)
        if (index > 0) {
          inputsRef.current[index - 1].focus()
        }
      } else if (index > 0) {
        inputsRef.current[index - 1].focus()
      }
    }
  }

  if (luckyNumberStatus) {
    return <></>
  }

  return (
    <>
      <SearchNumbersTitle>
        <div className="title">
          <span className="title-text">ค้นหาตัวเลขที่ต้องการ</span>
          <div className="subtitle">
            <label className="text">กรุณาระบุตำแหน่งและเลขที่ต้องการ</label>
            <div
              className="clear-button"
              onClick={() => {
                onChange(Array(7).fill(''))
              }}
            >
              <span>
                ล้างค่า <Icon.clearLuckyNumber />
              </span>
            </div>
          </div>
        </div>
        <div className="digits">
          <div className="digit-blue">5xx</div>
          <div className="dash">-</div>
          {value.map((value, index) => (
            <input
              className={`digit${index == 2 ? '-add-margin' : ''}`}
              key={index}
              ref={(el) => (inputsRef.current[index] = el)}
              type="tel"
              inputMode="numeric"
              pattern="[0-9]"
              value={value}
              onChange={() => {}}
              onKeyDown={(e) => handleKeyDown(e, index)}
            />
          ))}
        </div>
        <div className="subtitle">
          <div className="search-button" onClick={searchLuckyNumberOptions}>
            <span>
              <Icon.searchLuckyNumber />
              ค้นหาตัวเลข
            </span>
          </div>
          <div
            className="auto-assign-button"
            onClick={() => {
              setConfirmLuckyNumberModal({ modal: true, from: 'auto-assign' })
            }}
          >
            <span>ระบบเลือกตัวเลขให้</span>
          </div>
        </div>
      </SearchNumbersTitle>
      <Modal
        id="used-lucky-number-modal"
        className={'used-lucky-number-modal'}
        isOpen={isConfirmLuckyNumberModal.modal}
        size="md"
        modalClassName="default-bootstrap"
        toggle={() => {
          setConfirmLuckyNumberModal({ modal: false })
          setAutoAssignLuckyNumber(false)
        }}
      >
        <ModalTitleSection
          tag="div"
          toggle={() => {
            setConfirmLuckyNumberModal({ modal: false })
            setAutoAssignLuckyNumber(false)
          }}
        >
          <span className="modal-header-sub-title">กรุณาตรวจสอบ</span>
        </ModalTitleSection>

        <ModalBody className="modal-body-content" style={{ textAlign: 'center', margin: '20px 0 10px 0' }}>
          ระบบได้ทำการเลือกเลขกรมธรรม์เรียบร้อยแล้ว
          <br />
          หากกดปุ่ม "ยืนยัน" ท่านจะไม่สามารถแก้ไขเลขกรมธรรม์ได้อีก
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center', borderTop: 0 }}>
          <Button
            className="back-button"
            onClick={() => {
              setConfirmLuckyNumberModal({ modal: false })
              setAutoAssignLuckyNumber(false)
            }}
          >
            แก้ไข
          </Button>
          <Button
            color="primary"
            onClick={() => {
              setConfirmLuckyNumberModal({ modal: false })
              if (isConfirmLuckyNumberModal.from === 'auto-assign') {
                setAutoAssignLuckyNumber(true)
              } else if (isConfirmLuckyNumberModal.from === 'normal-assign') {
                submitSelectedLuckyNumber()
              }
            }}
          >
            ยืนยัน
          </Button>
        </ModalFooter>
      </Modal>
      <Modal
        id="auto-assign-failed-modal"
        className={'auto-assign-failed-modal'}
        isOpen={isAutoAssignFailedModal}
        size="md"
        modalClassName="default-bootstrap"
        toggle={() => {
          setAutoAssignFailedModal(false)
        }}
      >
        <ModalTitleSection
          tag="div"
          toggle={() => {
            setAutoAssignFailedModal(false)
          }}
        >
          <span className="modal-header-sub-title">แจ้งเตือน</span>
        </ModalTitleSection>

        <ModalBody className="modal-body-content" style={{ textAlign: 'center', margin: '20px 0 10px 0' }}>
          ขณะนี้ระบบไม่สามารถดำเนินการเลือกเลขกรมธรรม์ให้ท่านได้ กรุณาลองใหม่อีกครั้ง หรือ ค้นหาเลขกรมธรรม์ด้วยตนเอง
        </ModalBody>
        <ModalFooter style={{ justifyContent: 'center', borderTop: 0 }}>
          <Button
            color="primary"
            onClick={() => {
              setAutoAssignFailedModal(false)
            }}
          >
            ยืนยัน
          </Button>
        </ModalFooter>
      </Modal>
    </>
  )
}

export default LuckyNumberInput
